var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrdery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3961",
    "data-name": "Rectangle 3961",
    width: 24,
    height: 24,
    transform: "translate(60 235)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4745",
    "data-name": "Mask Group 4745",
    transform: "translate(-60 -235)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7633",
    "data-name": "Group 7633",
    transform: "translate(63 237.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7632",
    "data-name": "Group 7632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8236",
    "data-name": "Path 8236",
    d: "M17.989,15.691c-.069-.785-.164-1.58-.257-2.349q-.058-.485-.114-.97-.188-1.645-.378-3.29l-.2-1.7q-.2-1.751-.4-3.5c-.02-.171-.037-.342-.055-.513-.044-.425-.089-.864-.169-1.291A2.559,2.559,0,0,0,13.843,0L10.264,0H4.646C4.395,0,4.19,0,4,.007A2.553,2.553,0,0,0,1.551,2.2c-.089.667-.165,1.346-.239,2q-.049.434-.1.868L1.084,6.2Q.85,8.2.618,10.208q-.066.574-.133,1.147C.343,12.576.2,13.838.061,15.082l-.006.056a4.488,4.488,0,0,0-.023,1.208A2.54,2.54,0,0,0,2.6,18.472l2.575,0h7.667c1,0,1.827,0,2.592,0a2.6,2.6,0,0,0,1.907-.836,2.52,2.52,0,0,0,.65-1.943m-16.475.046c.031-.306.066-.609.107-.97q.257-2.224.515-4.448.119-1.025.238-2.051.137-1.178.274-2.357.051-.441.1-.882c.094-.8.19-1.623.277-2.436A1.083,1.083,0,0,1,4.2,1.524h9.6a1.086,1.086,0,0,1,1.169,1.07c.11,1,.23,2.024.346,3.01q.083.709.166,1.419.127,1.1.253,2.2t.253,2.192l.065.563c.133,1.148.27,2.334.408,3.5a1.349,1.349,0,0,1-.133.986,1.071,1.071,0,0,1-.946.49H5.38l-2.782,0a1.088,1.088,0,0,1-.823-.345,1.105,1.105,0,0,1-.261-.868",
    transform: "translate(0)",
    fill: "#ffc400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8237",
    "data-name": "Path 8237",
    d: "M90.934,49.179c.007.089.012.178.017.267a5.485,5.485,0,0,0,.055.592,3.983,3.983,0,0,0,3.58,3.341,3.839,3.839,0,0,0,.429.024,4.024,4.024,0,0,0,3.632-2.39,4.924,4.924,0,0,0,.346-2.22.776.776,0,0,0-.752-.823h-.011a.771.771,0,0,0-.761.826c0,.079,0,.158,0,.237a5.788,5.788,0,0,1-.036.745,2.5,2.5,0,0,1-2.442,2.1h-.011a2.5,2.5,0,0,1-2.463-2.088,5.724,5.724,0,0,1-.037-.745c0-.093,0-.186,0-.278a.77.77,0,0,0-.755-.8h-.007a.765.765,0,0,0-.76.809c0,.089,0,.178,0,.268v.021l-.026,0Z",
    transform: "translate(-85.977 -45.36)",
    fill: "#ffc400"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdery);
export default __webpack_public_path__ + "static/media/ordery.9f7abbefe9d62efd31f6f7e7f8f6d18d.svg";
export { ForwardRef as ReactComponent };